import { render } from "./ModifySwift.vue?vue&type=template&id=4827f874&scoped=true"
import script from "./ModifySwift.vue?vue&type=script&lang=js"
export * from "./ModifySwift.vue?vue&type=script&lang=js"

import "./ModifySwift.vue?vue&type=style&index=0&id=4827f874&scoped=true&lang=css"
import "./ModifySwift.vue?vue&type=style&index=1&id=4827f874&scoped=true&lang=scss"
import "./ModifySwift.vue?vue&type=style&index=2&id=4827f874&lang=scss"
import "./ModifySwift.vue?vue&type=style&index=3&id=4827f874&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4827f874"]])

export default __exports__